import { GLDistributionTableMultiSource } from "../../../backoffice/src/GLDistributionTableMultiSource";
import { DataSource, HorizontalSpacer, Label, Layout, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMiscInvoiceHistoryExpand extends Layout {
    glDistributionTable: GLDistributionTableMultiSource;
    horizontalspacer1: HorizontalSpacer;
    labelInvoiceDetail: Label;
    miscInvoiceHistoryDetailTable: Layout;
    sourceGLDistribution: DataSource;
    sourceJournalSales: DataSource;
    sourceMBDetailHist: DataSource;
    sourceMiscBillHist: DataSource;
    tabGlDistribution: Tab;
    tabInterfaces: Tab;
    tabInvoiceDetail: Tab;
    tabsetMiscInvoiceRow: Tabset;
    textboxAllocationCode: Textbox;
    textboxGpExported: Textbox;
}
